<template lang="pug">
    .termo-compromisso-assinaturas(v-if='assinaturasInformacoes')      
        .square 
            .icon-check_sign.mdi.mdi-check-bold Documento com Assinaturas Válidas
        .content-slot
            .assinatura-infos.b  Informações Gerais do Arquivo
            .linha            
            .assinatura-infos  <b>Número do Car: </b> {{ assinaturasInformacoes.numeroCar}}
            .assinatura-infos(v-if='assinaturasInformacoes.numeroTCA')  <b>Número do TCA: </b> {{ assinaturasInformacoes.numeroTCA}}
            .assinatura-infos(v-if='assinaturasInformacoes.numeroTCPRA')  <b>Número do TCPRA: </b> {{ assinaturasInformacoes.numeroTCPRA}}
            .assinatura-infos <b>Número do PRADA: </b> {{ assinaturasInformacoes.numeroPrada}}
            .assinatura-infos  <b>Data da Validação: </b>{{ getFormatedDate() }}            
            .linha            
        .tc-header
        .divider
        .tc-content
            .linha            
            .assinaturas-obrigatorias(v-if='assinaturasInformacoes.assinaturas')                      
                TermoCompromissoAssinaturaBoxComponent(
                    v-for='(assinatura, i) in assinaturasInformacoes.assinaturas',
                    :key='i',
                    :assinatura='assinatura'
                )          


        .tc-footer        
            
</template>

<script>
import TermoCompromissoAssinaturaBoxComponent from '@/views/termoCompromisso/components/TermoCompromissoAssinaturaBoxComponent.vue';

import moment from 'moment';

export default {
    name: 'TermoCompromissoAssinatura',
    components: {
        TermoCompromissoAssinaturaBoxComponent,
    },
    props: {
        assinaturasInformacoes: Object,
    },

    data() {
        return {};
    },

    async mounted() {},

    methods: {
        getFormatedDate() {
            if (this.assinaturasInformacoes.dataValidacao)
                return moment.utc(String(this.assinaturasInformacoes.dataValidacao)).format('DD/MM/YYYY HH:mm:ss');
            return 'Validação Pendente';
        },
    },
};
</script>

<style lang="scss" scoped>
.termo-compromisso-assinaturas {
    max-height: 75vh;
    overflow-y: auto;
    background-color: transparent;
    text-align: justify;

    .square {
        background-color: var(--primary-green);
        position: relative;
        width: 75vh;
        height: 5vh;
        margin-bottom: 10px;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .icon-check-sign-header {
        background-color: transparent;
        color: var(--primary-green);
        display: flex;
        align-items: center;
    }

    .divider {
        width: 100%;
        border-bottom: 2px solid var(--primary-black);
        position: relative;
    }

    .assinaturas-obrigatorias {
        margin-left: 4vw;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .tc-footer {
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .content-slot {
        .b {
            font-weight: bolder;
        }
    }
}

.termo-compromisso-assinaturas::-webkit-scrollbar {
    width: 8px;
}

.termo-compromisso-assinaturas::-webkit-scrollbar-track {
    background-color: var(--primary-smoke);
}
</style>
